module.exports = ".popup_image{\r\n    max-width:80vw;\r\n    max-height:80vh\r\n}\r\n.center{\r\n    text-align: center\r\n}"